import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterPipe'
})
export class FilterPipePipe implements PipeTransform {

  transform(items: any[], field: string, value: any): any[] {
    if (!items) return [];
    if (!value || value.length == 0) return items;
    return items.filter(
      it => it[field] === value
    );
  }

}
